export enum SystemType {
  Android,
  iOS,
  Unknown
}
